import React, {useRef, useState, useEffect, useCallback} from 'react';
import styles from './PortraitVideo.module.scss'
import NavToggle from "components/icons/navToggle/NavToggle";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import {useDispatch, useSelector} from "react-redux";
import {buttonClick} from "utils/Helpers";

const PortraitVideo = (props) => {

    const accessible = useSelector(state => state.accessible);
    const windowData = useSelector(state => state.window);
    const dispatch = useDispatch();
    const videoWrapper = useRef()
    const player = useRef()
    const [isPlaying, setIsPlaying] = useState(false);

    const setVideoSize = useCallback(() =>{

        videoWrapper.current.style.width = '';
        videoWrapper.current.style.height = '';
        let width = videoWrapper.current.getBoundingClientRect().width;
        let height = videoWrapper.current.getBoundingClientRect().height;
        let designatedHeight = width * 1.77;
        let designatedWidth = height * .562;
        if (width > designatedWidth) videoWrapper.current.style.width = designatedWidth + 'px';
        if (height > designatedHeight) videoWrapper.current.style.height = designatedHeight + 'px';

    }, []);

    useEffect(()=>{
        setVideoSize()
    },[windowData,setVideoSize]);

    function toggleVideo(){
        let videos = document.querySelectorAll('.portraitVideo');
        videos.forEach((video)=>{
            video.pause();
        })

        setTimeout(()=>setIsPlaying(!isPlaying), 100)

    }

    function isVideoPlaying(play){
        dispatch({ type: "SET_ACCESSIBLE",
            payload: {
                ...accessible,
                videoActive: play
            }
        });
    }

    function buildPlayer(){
        if(isPlaying){
            return (
                <>
                    <video ref={player} className={`portraitVideo ${styles.videoPlayer}`} controls playsInline autoPlay fullScreen preload="metadata"
                           onPause={()=>isVideoPlaying(false)} onPlay={()=>isVideoPlaying(true)}>
                        <source src={`${props.src}?v=portrait`} type="video/mp4"/>
                        {props.cc && <track label="English" kind="subtitles" srcLang="en" src={props.cc}/>}
                    </video>
                    <div aria-hidden={accessible.modalOpen} tabIndex={0} role={'button'} aria-label={'Close video'} className={styles.close} onKeyDown={buttonClick} onClick={toggleVideo}><NavToggle menuOpen={true} closeOnly={true} color={'#fff'}/></div>
                </>
            )
        } else {
            return (
                <>
                    <ImageWrapper aria-hidden={accessible.modalOpen} className={styles.poster} set={{default: props.poster}} alt={'Video poster'}/>
                    <ImageWrapper aria-hidden={accessible.modalOpen} tabIndex={0} role={'button'} aria-label={'Play video'} className={styles.play} onKeyDown={buttonClick} onClick={toggleVideo}
                                  set={{default: 'https://msobd-storage.azureedge.net/images/play.png'}} alt={''}/>
                </>
            )
        }
    }

    return (
        <div ref={videoWrapper} className={styles.videoWrapper}>
            {buildPlayer()}
        </div>
    )
};

export default PortraitVideo
